// extracted by mini-css-extract-plugin
export default {"settings":"VPoqvQ76O0LQ9s2pNgSc","container":"Z8tq_4KBiEKr8gt1shLC"};